import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';

export const Logo = styled('img')`
  height: ${pxToRem(30)};
`;

export const LogoWrapper = styled('div')`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: ${({ theme }) => theme.lineHeight['2xl']};
`;
